import {testIdProps} from '@github-ui/test-id-props'
import {Link} from '@primer/react'
import {use} from 'react'

import {ViewContext} from '../hooks/use-views'
import {Link as RouterLink} from '../router'
import styles from './column-settings-saved-message.module.css'

/**
 * Message to show on column settings page when the user succesfully saves changes.
 */
export function ColumnSettingsSavedMessage({title}: {title: string}) {
  const viewContext = use(ViewContext)

  // Normally ViewContext will be provided, but it's not available in unit test environment
  return (
    <span className={styles.Text} {...testIdProps('column-settings-saved-message')}>
      Changes saved. Return to{' '}
      {viewContext ? (
        <Link
          as={RouterLink}
          to={viewContext.returnToViewLinkTo}
          style={{cursor: 'pointer'}}
          tabIndex={0}
          {...testIdProps('return-to-project-link')}
        >
          {title}
        </Link>
      ) : (
        title
      )}
      .
    </span>
  )
}
